import { Component, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ConfigurationService } from '@urbannex/configuration';
import { OfbizFormsService } from '@urbannex/ofbiz-forms';
import { SectionBuilderStoreService } from '../../section-builder-store.service';
import { BaseStepperDirective } from '../base-stepper.directive';
import { ContentStatusEnum, GridCell, RowCell, Section } from '@urbannex/storethemes';


@Component({
  selector: 'kve-blog-article-link-stepper',
  templateUrl: './blog-article-link-stepper.component.html',
  styleUrls: ['./blog-article-link-stepper.component.scss']
})
export class BlogArticleLinkStepperComponent extends BaseStepperDirective implements OnInit, OnChanges{
  @Input() cell:GridCell | RowCell;
  @Input() section:Section;
  
  constructor(ofbizFormsService:OfbizFormsService,
    sectionBuilderStoreService:SectionBuilderStoreService,
    configurationService:ConfigurationService,){
    super(ofbizFormsService,sectionBuilderStoreService,configurationService,)
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes)
  }

  onSubmitContent(){
    console.log("onSubmitContent")
    this.cell.status = ContentStatusEnum.CTNT_INITIAL_DRAFT;
    this.section.status = ContentStatusEnum.CTNT_INITIAL_DRAFT;
    this.sectionBuilderStoreService.updateSection(this.section);
    this.sectionBuilderStoreService.updateSelectedCell(this.cell);
    this.closeHostDialog.emit();
  }
 
}
